import React from "react";
import AuthHeader from "../../../components/AuthHeader/AuthHeader";
import { Outlet } from "react-router-dom";

export default function AuthLayout() {
  return (
    <div className="bg-gradient-theme h-screen min-vh-100 d-flex flex-column">
      <AuthHeader />
      <div className="d-flex flex-grow-1 justify-content-center align-items-center py-40">
        <Outlet />
      </div>
    </div>
  );
}
